export default __webpack_public_path__ + "static/media/fasfion.7b89ed91.png";